<!-- resources/js/Layout/Footer.vue -->
<template>
  <footer class="bg-[hsl(142_84%_2%)] border-t border-[hsl(var(--border))] text-white">
    <div class="container mx-auto px-4 py-8 max-w-5xl">
      <!-- Horní část: kontakty a logo/popis -->
      <div class="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8 mb-8">
        <!-- Kontaktní údaje -->
        <div class="flex flex-col sm:flex-row flex-wrap justify-center sm:justify-start items-center gap-6 w-full lg:w-auto">
          <div class="flex items-center gap-2">
            <MapPinIcon class="h-5 w-5 text-primary" />
            <span class="text-base font-semibold text-white">
              123 Elite Drive, Luxury District, LD 12345
            </span>
          </div>
          <div class="flex items-center gap-6">
            <div class="flex items-center gap-2">
              <PhoneIcon class="h-5 w-5 text-primary" />
              <span class="text-base font-semibold text-white">
                +420 123 456 789
              </span>
            </div>
            <div class="flex items-center gap-2">
              <MailIcon class="h-5 w-5 text-primary" />
              <span class="text-base font-semibold text-white">
                email@email.cz
              </span>
            </div>
          </div>
        </div>

        <!-- Název a sociální ikony -->
        <div class="text-center lg:text-right w-full lg:w-auto">
          <div class="text-2xl md:text-3xl font-bold text-white mb-2">
            Elite Auto Imports
          </div>
          <p class="text-sm md:text-base text-[hsl(142_20%_80%)] leading-snug mb-4">
            Přivážíme ta nejprestižnější vozidla pro náročné automobilové nadšence z celého světa.
          </p>
          <div class="flex justify-center lg:justify-end space-x-4">
            <a href="#"><FacebookIcon class="h-5 w-5 text-primary" /></a>
            <a href="#"><TwitterIcon class="h-5 w-5 text-primary" /></a>
            <a href="#"><InstagramIcon class="h-5 w-5 text-primary" /></a>
            <a href="#"><LinkedinIcon class="h-5 w-5 text-primary" /></a>
          </div>
        </div>
      </div>

      <!-- Spodní lišta s odkazem -->
      <div class="text-center border-t border-white/20 pt-4 text-sm text-muted-foreground">
        Vytvořeno <a href="https://webnetwork.cz" target="_blank" class="underline hover:text-primary">Webnetwork.cz</a>
      </div>
    </div>
  </footer>
</template>

<script setup>
import {
  Phone as PhoneIcon,
  Mail as MailIcon,
  MapPin as MapPinIcon,
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  Instagram as InstagramIcon,
  Linkedin as LinkedinIcon
} from 'lucide-vue-next'

</script>

<style scoped>
/* Footer s tmavým pozadím a optimalizovanou čitelností */
</style>
